import { format } from '@ustra/core/src/utils/json-utils'

/**
 * json을 포맷팅하는 필터
 */
export default (value: string, space: number = 4): string => {
  return format(value, space)
}
